(function($) {

  var $tabsWrap = $('.provider-search-tabs');
  var $tabs = $tabsWrap.find('.nav-link');
  var $searchFields = $('.provider-search-input');

  $tabs.click(function(e) {
    e.preventDefault();
    $('.asl-overlay').show();
    var $this = $(e.currentTarget);
    var cls = $this.attr('data-class');
    if (!$this.hasClass('active')) {
      $tabs.removeClass('active');
      $this.addClass('active');

      var $searchField = $('.' + cls);
      if ($searchField.length) {
        $searchFields.removeClass('hide');
        $searchField.addClass('hide');
      }
      var $ddGroup = $('.asl-dist-dd .adropdown-menu li');
      // if ($ddGroup.length) {
        if (cls == 'asl-name-search') {
          window.setTimeout(function() {
            // var val = $ddGroup.filter('.active').find('input').val();
            if (window.asl_view) {
              asl_view.second_filter = {
                type: "title",
                title: ''
              };
            }
            $('#sl-main-search-name').val('');
            asl_view.clear_search(e);
            // $('.provider-search-name-wrap').find('.asl-clear-btn').trigger('click');
            asl_configuration.radius_range = '5';
            $('.asl-dist-ddl').val('5');
          }, 250);
        } else if (cls == 'asl-loc-search') {
          window.setTimeout(function() {
            $('.provider-search-address-wrap').find('.asl-clear-btn').trigger('click');
          }, 250);
          // asl_configuration.fixed_radius = asl_configuration.radius_range = '500';
          // $('.asl-dist-ddl').val('500');
          // $ddGroup.filter(':last-child').find('label').trigger('click');
        }
      // }
    }
  });

  function buildDistDropdown() {
    var distStr = asl_configuration.dropdown_range.split(","),
    option = "",
    unitWord = ("KM" == asl_configuration.distance_unit) ? asl_configuration.words.Km : asl_configuration.words.Miles;
    for (var y = 0;y < distStr.length;y++) {
      var distVal = distStr[y];
      option += !(!distVal || "*" != distVal[0])
        ? '<option selected="selected" value="' +
          (distVal = distVal.replace("*", "")) +
          '">' +
          distVal +
          " " +
          unitWord +
          "</option>"
        : '<option value="' +
          distVal +
          '">' +
          distVal +
          " " +
          unitWord +
          "</option>";
    }
    asl_view._cont
    .find(".range_filter")
    .html('<div class="asl-filter-cntrl"><label class="asl-cntrl-lbl">' +
        asl_configuration.words.distance +
        '</label><div class="sl-dropdown-cont"><select class="asl-dist-ddl">' +
        option +
        "</select></div></div>")
    .removeClass("hide")
    .addClass('d-block');
    "1" == asl_configuration.template &&
      asl_view._cont
        .find(".range_filter")
        .prepend(
          "<label>" + asl_configuration.words.in + "</label>"
        ),
    (asl_view.$dist_control = asl_view._cont.find(".asl-dist-ddl")),
    asl_view.$dist_control.multiselect({
      enableFiltering: !1,
      nonSelectedText: asl_configuration.words.select_distance,
      numberDisplayed: 1,
      maxHeight: asl_configuration.ddl_max_height
        ? parseInt(asl_configuration.ddl_max_height)
        : 250,
      onChange: function(e, t) {
        e = parseInt(e.val());
        isNaN(e) && (e = 1e3),
          (asl_configuration.radius_range = e),
          asl_view.refreshView(),
          asl_view.$circle && h(asl_view.dest_coords);
      }
    }),
    (asl_configuration.radius_range = asl_view.$dist_control.val());
  }

  window.asl_event_hook = function(data) {
    console.log(data);
    $('.asl-overlay').hide();
    var $distGroup = $('.search-filters-wrap');
    if ($distGroup.length) {
      if (data.type == 'geolocation' || data.type == 'search' || data.type == 'load') {
        // buildDistDropdown();
        $distGroup.removeClass('d-none');
      }
    }
    if (data.type == 'geolocation' || data.type == 'search' || (window.location.search.includes("sl-addr=") && data.type == 'load')) {
      // buildDistDropdown();
      $('.asl-dist-dd').removeClass('d-none');
    }
  }

  $('#asl-storelocator .asl-search-btn').click(function(e) {
    e.preventDefault();
    var $this = $(e.target),
    $input = $('#sl-main-search-name');
    var val = $input.val();
    if (val.length) {
      $input.next().removeClass('hide');
      asl_view.second_filter = {
        type: "title",
        title: val
      };
    } else {
      asl_view.second_filter = {
        type: "title",
        title: ''
      };
    }
    asl_configuration.fixed_radius = asl_configuration.radius_range = '500';
    $('.asl-dist-ddl').val('500');
    // asl_configuration.fixed_radius = '500';
    // asl_configuration.radius_range = '500';
    asl_view.refreshView();
    // asl_configuration.fixed_radius = '500';
    // asl_configuration.radius_range = '500';
    var stores = asl_view.get("stores");
    asl_view.fitBound(stores);
  });
  $('#sl-main-search-name').on('keydown', function(e) {
    if (e.which == 13) {
      $('#asl-storelocator .asl-search-btn').trigger('click');
    }
  });
  // $(window).load(function(e) {
  //   if (window.location.search.includes("sl-addr=")) {

  //   }
  // });
})(jQuery);
